import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  appSumoActions,
  appSumoSelectors
} from '../../../../store/modules/appSumo';

const useAppSumoRedeemHandler = () => {
  const dispatch = useDispatch();
  const handler = useCallback(
    (code: string) => dispatch(appSumoActions.activateCoupon({ code })),
    []
  );

  const submitError = useSelector(appSumoSelectors.selectCouponError);

  return [handler, submitError?.message] as const;
};

export default useAppSumoRedeemHandler;
